import { render, staticRenderFns } from "./MyNFT.vue?vue&type=template&id=67d5bf93&scoped=true"
import script from "./MyNFT.vue?vue&type=script&lang=js"
export * from "./MyNFT.vue?vue&type=script&lang=js"
import style0 from "./MyNFT.vue?vue&type=style&index=0&id=67d5bf93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d5bf93",
  null
  
)

export default component.exports